import { render } from "./SalesByGenderChart.vue?vue&type=template&id=62340dda&ts=true"
import script from "./SalesByGenderChart.vue?vue&type=script&lang=ts"
export * from "./SalesByGenderChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__